import { render, staticRenderFns } from "./OrderFooter.vue?vue&type=template&id=9fbe0334&"
import script from "./OrderFooter.vue?vue&type=script&lang=js&"
export * from "./OrderFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports